import React from "react";
import { motion } from "framer-motion";

const controller = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const controller_2 = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Certificate = ({ title }) => {
  const overlay = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center -p-16b text-deep-blue
    
    `;
  return (
    <motion.div className="relative" variants={controller_2}>
      <div className={overlay}>
        <p className="font-semibold font-lato">{title}</p>
        {/* <p className="font-semibold font-poppins mt-3 p-4">{description}</p> */}
      </div>
      <img
        style={{ pointerEvents: "none" }}
        src={require(`/src/Resource/image/projects/${title}.jpg`)}
        alt={title}
      />
    </motion.div>
  );
};

export default function Certificates() {
  return (
    <section id="certificate" className="pt-20 pb-10">
      <motion.div
        className="md:w-2/4 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-lato font-semibold text-4xl ">
            <span className="text-red">Cer</span>tificates
          </p>
        </div>
      </motion.div>

      <div className="flex justify-center mt-10">
        <motion.div
          className="sm:grid sm:grid-cols-3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={controller}
        >
          <Certificate title="Internship" />
          <Certificate title="Python" />
        </motion.div>
      </div>
    </section>
  );
}
